import {
  getData, ifOkToJson, isDataFine, post, get,
  addRequestBody
} from './index'
import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-message`
let baseUrl85 = `${httpUrl.host}/gy-apartment`
let baseUrl84 = `${httpUrl.host}/gy-guard`

let api = {
  // 消息统计
  getStatistics: `${baseUrl}/messageOverview/getStatistics`,

  // 消息推送记录统计
  getMessageRecordSendStatistics: `${baseUrl}/messageOverview/getMessageRecordSendStatistics`,

  // 获取公告列表
  getNoticeList: `${baseUrl85}/yqNotice/getList`,

  // 获取模板分页
  getWxTemplatePage: `${baseUrl}/wxTemplate/getPage`,

  // 同步模板
  syncTemplateWxTemplate: `${baseUrl}/wxTemplate/syncTemplate`,

  // 删除模板
  deleteWxTemplate: `${baseUrl}/wxTemplate/delete`,

  // 获取模板列表
  getWxTemplateList: `${baseUrl}/wxTemplate/getList`,

  // 获取模板详情
  getWxTemplateById: `${baseUrl}/wxTemplate/getByTemplateId`,

  // 发送消息
  sendCustomMessage: `${baseUrl}/messageSend/sendCustomMessage`,

  // 重置配置
  resetWxPushConfig: `${baseUrl}/wxPushConfig/reset`,

  // 查询配置
  getWxPushConfigPage: `${baseUrl}/wxPushConfig/getPage`,

  // 保存配置
  saveOrUpdateWxPushConfig: `${baseUrl}/wxPushConfig/saveOrUpdate`,

  // 查询配置详情
  getWxPushConfigByCode: `${baseUrl}/wxPushConfig/getByCode`,

  // 查询类型
  getWxEventConfigTree: `${baseUrl}/wxEventConfig/getTree`,

  // 查询所有类型列表
  getWxEventConfigList: `${baseUrl}/wxEventConfig/getList`,

  // 查询未有类型列表
  getListForConfig: `${baseUrl}/wxEventConfig/getListForConfig`,

  // 查询类型详情
  getWxEventConfigByCode: `${baseUrl}/wxEventConfig/getByCode`,

  // 添加消息模板
  addMessageTemplate: `${baseUrl}/customizeMessageSend/add`,

  // 修改消息模板
  updateMessageTemplate: `${baseUrl}/customizeMessageSend/update`,

  // 消息模板详情
  getMessageTemplateByCode: `${baseUrl}/customizeMessageSend/getByCode`,

  // 消息模板
  getMessageTemplateByPage: `${baseUrl}/customizeMessageSend/getByPage`,

  // 删除消息模板
  deleteMessageTemplateByCodes: `${baseUrl}/customizeMessageSend/deleteByCodes`,

  // 消息推送
  sendMessage: `${baseUrl}/customizeMessageSend/sendMessage`,

  // 消息推送统计
  getMessageRecord: `${baseUrl}/messageOverview/getMessageRecordSendStatistics`,

  // 人员列表
  getResponsiblePersonList: `${baseUrl85}/person/getResponsiblePersonList`,

  // 上传图片
  getMessageRecordPage: `${baseUrl}/messageSend/getRecordPage`,

  getBasicPersonPage (data) {
    return post(`${baseUrl84}/authority/getPersonPage`, data)
      .then(ifOkToJson)
      .then(getData)
  },

  getEnterpriseInfoList () {
    return post(`${baseUrl85}/enterpriseInfo/getEnterpriseList`, {})
      .then(ifOkToJson)
      .then(getData)
  }
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/Message.js